import React, { useEffect, useState } from "react";
import splashBg from "../assets/bgspin.png";

const Spinner = ({ visible = true }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
    } else {
      // Даём анимации исчезновения доиграть
      const timeout = setTimeout(() => setShouldRender(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [visible]);

  if (!shouldRender) return null;

  return (
    <div
      className={`
        fixed inset-0 z-[9999] pt-24 flex flex-col items-center overflow-hidden
        transition-opacity duration-700 ease-in-out
        ${visible ? "opacity-100" : "opacity-0"}
      `}
    >
      {/* Фоновая картинка */}
      <div
        className="absolute inset-0 bg-center bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${splashBg})`,
        }}
      />

      {/* Контент поверх изображения - выровнен по верху */}
      <div
        className={`
          relative z-10 w-full flex flex-col items-center text-center px-6
          transition-all duration-700 ease-out pt-16 md:pt-24
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}
      >
        {/* Основной блок с текстом - смещен к верху */}
        <div className="flex flex-col items-center w-full">
          {/* Заголовок "Академия" */}
          <div 
            className="text-[32px] leading-tight italic font-normal text-white mb-1"
            style={{
              fontFamily: "'Philosopher', sans-serif",
              fontWeight: 400,
              fontStyle: 'italic'
            }}
          >
            Академия
          </div>

          {/* Подзаголовок "медитативного творчества" */}
          <div className="text-white/90 text-lg italic mb-8">
            медитативного творчества
          </div>

          {/* Логотип "Inner Art" */}
          <div 
            className="w-full"
            style={{
              fontSize: '71.26px',
              lineHeight: '140%',
              fontFamily: "'Philosopher', sans-serif",
              fontWeight: 700,
              fontStyle: 'italic'
            }}
          >
            <span 
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage: 'linear-gradient(to right, #6C6FF8, #F466C8)'
              }}
            >
              Inner Art
            </span>
          </div>
        </div>

        {/* Пустое пространство снизу для выравнивания по верху */}
        <div className="flex-grow"></div>
      </div>
    </div>
  );
};

export default Spinner;